import { useLayout } from '@approvalmax/ui/src/components';
import { browserHelpers } from '@approvalmax/utils';
import { selectors } from 'modules/common';
import { hocs as pageHocs } from 'modules/page';
import { useSelector } from 'modules/react-redux';
import { memo, useEffect } from 'react';
import { routingService } from 'services/routing';

import { Content } from './resources/components';

const Page = memo(() => {
    useLayout({ containerMinSize: 'xxsmall' });

    const companies = useSelector(selectors.company.companiesSelector);
    const isNoCompanies = companies.length === 0;
    const isMobile = browserHelpers.isMobile();

    const canShowPage = isMobile && isNoCompanies;

    useEffect(() => {
        if (!canShowPage) {
            routingService.pushToDefaultPath();
        }
    }, [canShowPage, isMobile, isNoCompanies]);

    if (!canShowPage) {
        return null;
    }

    return <Content />;
});

Page.displayName = 'Page';

export default pageHocs.withProtected({ Page });
